<template>
    <el-table-column :render-header="renderHeader" :label="label" :sortable="sortable" :prop="prop" :key="prop" :fixed="fixed" :width="width">
        <el-table-column label-class-name="summary-column" :label="getSummary(prop)||'--'" :fixed="fixed" :prop="prop" :width="width">
            <span slot-scope="sp">
            <span v-if="!is_slot" :class="getClass(sp.row[prop],prop)" :key="prop">{{sp.row[prop]}}</span>
            <span v-else><slot :sp="sp"/></span>
            </span>
        </el-table-column>
    </el-table-column>
</template>

<script>
export default {
    props:{
        label:{
            type:String,
            default(){return ''}
        },
        prop:{
            type:String,
            default(){return ''}
        },
        sortable:{
            default(){return false}
        },
        summary:{
            type:String,
            default(){return ''}
        },
        width:{
            type:String
        },
        fixed:{
            default(){return false}
        },
        is_slot:{
            default(){return false}
        }
    },
    methods:{
		renderHeader(h,data) {
            const label = data.column.label;
            return (
                <span class="header-column">{label}</span>
            );
        },
        getClass(data,type) {
            switch (type) {
                case 'cvr':
                case 'sent_cvr':
                    if (parseFloat(data) >= 1.5) {
                        return 'status-active';
                    } else if(parseFloat(data) >= 0.03){
                        return 'status-pink';
                    } else {
                        return 'status-paused';
                    }
                case 'profit':
                    if(data > 0){
                        return 'status-active';
                    }else if(data < 0){
                        return 'status-paused';
                    }
            }
        }
    },
    inject:['getSummary']
}
</script>

<style scope>
.summary-column{
    font-weight: 500;
    align-self: flex-end;
    user-select: text;
    -webkit-user-select: text;
}
.header-column{
    margin:0px 0px 0px 0px;
    word-break: break-word;
}
</style>